/**
 * Debug logger utility for SDK
 * Logs are only printed when debug mode is enabled
 */

let debugEnabled = false;

/**
 * Enable or disable debug logging
 */
export function setDebugMode(enabled: boolean): void {
  debugEnabled = enabled;
}

/**
 * Check if debug mode is enabled
 */
export function isDebugEnabled(): boolean {
  return debugEnabled;
}

/**
 * Initialize debug mode from environment variable
 * Checks HYPERLIQUID_SDK_DEBUG environment variable
 */
export function initDebugMode(): void {
  // Check environment variable (works in Node.js and some bundlers)
  if (typeof process !== 'undefined' && process.env?.HYPERLIQUID_SDK_DEBUG === 'true') {
    debugEnabled = true;
  }
}

/**
 * Debug log - only prints if debug mode is enabled
 */
export function debugLog(...args: unknown[]): void {
  if (debugEnabled) {
    console.log(...args);
  }
}

/**
 * Debug warn - only prints if debug mode is enabled
 */
export function debugWarn(...args: unknown[]): void {
  if (debugEnabled) {
    console.warn(...args);
  }
}

/**
 * Error log - always prints (errors should always be visible)
 */
export function errorLog(...args: unknown[]): void {
  console.error(...args);
}

// Auto-initialize from environment on module load
initDebugMode();
